import moment from "moment";
import pluralize from "@/utils/pluralFormatting";

export const formatDate = (datestr, format) => {
    if (datestr != null) {
      return moment(String(datestr)).format(format);
    } else {
      return "";
    }
};

export const formatDateToLocal = (dateString) => {
    return moment(dateString).local().format('DD MMM YYYY HH:mm');
};

export const formatDateHourToLocal = (dateString) => {
    return moment(dateString).local().format('DD/MM/YYYY à HH:mm');
};

export const hoursAsDaysAndHours = (hours, hourText = ' heure', separator = ' et ', forceDisplayDays = false) => {
    const deferredDepositDelayHours = hours || 0;
    if (deferredDepositDelayHours === 0) {
        return "0 jours"
    }
    let text = "";
    const days = Math.floor(deferredDepositDelayHours / 24);
    if (days > 0 || forceDisplayDays) {
        text += pluralize('jour', days)
    }
    const hoursRest = deferredDepositDelayHours % 24;
    if (hoursRest !== 0)  {
    if (days > 0) {
        text += separator
    }
    text += pluralize(hourText, hoursRest)
    }
    return text;
};
